import { UserType } from 'app/services/external/auth-oidc/models/session.model';

export declare type CodeRoleType = 'WCAD' | 'TAAD';

export const RoleToUserType: Record<CodeRoleType, UserType | undefined> = {
  TAAD: 'Agency',
  WCAD: 'Corporate'
};
